import { TextChatMessagesService } from '../text-chat-messages/text-chat-messages.service';
import { Injectable } from '@angular/core';
import { BcRestApi } from 'common/api/rest-api';
import { MessageGroupModel } from 'shared/services/message-group/message-group.model';
import { ChatMessagesService } from 'common/chat-messages/chat-messages.service';
import { EmailsService } from 'common/emails/emails.service';

@Injectable()
export class VisitorsService {
  constructor(private _bcRestApi: BcRestApi,
              private _chatMessagesService: ChatMessagesService,
              private _emailService: EmailsService,
              private _textChatMessagesService: TextChatMessagesService) {
  }

  public getVisitorsEmailThreadHistory(emailThreadId: string) {
    return this._bcRestApi.getEmailThreadHistory(emailThreadId);
  }

  public getVisitorHistoryByChatId(chatId: string) {
    return this._bcRestApi.getVisitorHistoryByChatId(chatId);
  }

  public getVisitorHistoryChatDetails(itemId: string) {
    return this._chatMessagesService.getChatMessages(itemId);
  }

  public getVisitorHistoryEmailDetails(itemId: string) {
    return this._emailService.getEmailWithAttachments(itemId);
  }

  public getVisitorHistoryByTextChatId(textChatId: string) {
    return this._bcRestApi.getVisitorHistoryByTextChatId(textChatId);
  }

  public getVisitorHistoryTextChatDetails(itemId: string): Promise<MessageGroupModel[]> {
    return this._textChatMessagesService.getTextChatMessages(itemId);
  }
}
